import { Box } from "@chakra-ui/react";
import { FC } from "react";

interface VerticalLineProps {
  height?: string;
  thickness?: string;
  color?: string;
  marginX?: string;
}

const VerticalLine: FC<VerticalLineProps> = ({
  height = "12",
  thickness = "1px",
  color = "white",
  marginX = "2",
}) => {
  return (
    <Box
      height={height}
      width={thickness}
      backgroundColor={color}
      marginX={marginX}
    />
  );
};

export default VerticalLine;
